import {
  GET_PRODUCT_CASHIER,
  GET_PRODUCT_BY_BARCODE,
} from "../../actions/kasir/productCashier.action";

const initialState = {
  data: [],
  count: 0,
  loading: true,
  error: null,
  barcodeProduct: null,
  loadingBarcode: false,
  barcodeError: null,
};

const productCashierReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_CASHIER.LOADING:
      return {
        ...state,
        loading: action.load,
      };

    case GET_PRODUCT_CASHIER.SUCCESS:
      return {
        ...state,
        data: Array.isArray(action.data) ? action.data : [],
        count: Array.isArray(action.data) ? action.data.length : 0,
        loading: false,
        error: null,
      };

    case GET_PRODUCT_CASHIER.ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case GET_PRODUCT_BY_BARCODE.LOADING:
      return {
        ...state,
        loadingBarcode: action.load,
      };

    case GET_PRODUCT_BY_BARCODE.SUCCESS:
      return {
        ...state,
        barcodeProduct: action.data,
        loadingBarcode: false,
        barcodeError: null,
      };

    case GET_PRODUCT_BY_BARCODE.ERROR:
      return {
        ...state,
        barcodeError: action.error,
        loadingBarcode: false,
        barcodeProduct: null,
      };

    default:
      return state;
  }
};

export default productCashierReducer;
